import React, { useState, useEffect ,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  updateNodeFuctionalText,
  updateNodeFunctionalLevel,
  resetFilterSideBar,
} from "redux/actions";
import Slider from "react-slick";
import { NextArrow, PrevArrow } from "components/Common/Arrows";
import category_image from '../../../../assets/images/catering-item.jpg'
import useSmoothScroll from 'hooks/useSmoothScroll';

const HIDE_SUB_SUB_CHILD = false
export const querySearchParamKey = "category"
 
const ChildItem = ({ item, onClick, querySearchKey, level = 0 }) => {
  const dispatch = useDispatch();
  const [isChildNodesOpen, setIsChildNodesOpen] = useState(false);
  const setSearchParams = useSearchParams()[1];

  const image = item?.medium_image || item?.image || category_image

  const scrollToCategory = useSmoothScroll()

  const handleNodeChange = (
    e,
    text,
    funtional_level,
    function_names,
    category_ids,
    slug
  ) => {
    dispatch(updateNodeFuctionalText(text));
    dispatch(updateNodeFunctionalLevel(funtional_level));
    setSearchParams({ [querySearchParamKey]: slug });
    scrollToCategory(`catering-category-${slug}`, 300, 275)
    // if (querySearchKey === "category_ids") {
    //   setSearchParams({ category_ids: category_ids });
    // } else {
    //   setSearchParams({ function_names: function_names });
    // }
  };

  const handleItemClick = (e) => {
    handleNodeChange(
      e,
      item.text,
      item.funtional_level,
      item.function_names,
      item.category_ids,
      item.slug
    );
    if (item.node && item.node.length > 0) {
      setIsChildNodesOpen(true);
    }
  };

  return (
    <>
      <div>
        <div
          // className={
          //   nodeFunctionalText === item.text &&
          //   nodeFunctionalLevel === item.funtional_level
          //     ? "department-item active"
          //     : "department-item"
          // }
          className="department-item"
          onClick={handleItemClick}
          key={item.category_ids}

        >
          <div className="image">
            <img src={image} alt="catering product" />
          </div>
          <div className="title-alignment">

            {item.text}
            {item.product_count !== "0" ? `(${item.product_count})` : ""}
          </div>
          {/* { !HIDE_SUB_SUB_CHILD && item.node && item.node.length !== 0 && (
          <div
            onClick={handleToggleExpand}
          >
            {isChildNodesOpen ? <PlusSignIcon /> : <MinusSignIcon />} 
          </div>
        )} */}
        </div>

        {/* {HIDE_SUB_SUB_CHILD ? null : <div className="child-department-list">
        {isChildNodesOpen &&
          item.node &&
          item.node.map((childItem, index) => (
            <ChildItem
              key={index}
              item={childItem}
              onClick={onClick}
              querySearchKey={querySearchKey}
              level={level + 1}
            />
          ))}
      </div>} */}
      </div>
    </>
  );
};

const Item = (props) => {
  const {
    node,
    onClick,
    isChildNodesOpenDefault,
    category_ids,
    slug,
    text,
    product_count,
    isRootItem,
    funtional_level,
    function_names,
    redirectBaseUrl,
    querySearchKey,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const sliderRef = useRef(null);
  node?.sort((a, b) => +a.order_by - +b.order_by)

  const [isChildNodesOpen, setIsChildNodesOpen] = useState(isChildNodesOpenDefault);

  let setSearchParams = useSearchParams()[1];

  const { nodeFunctionalText, nodeFunctionalLevel } = useSelector(
    ({ product }) => product
  );

  const listRef = useRef(null);

const scroll = (direction) => {
  const scrollAmount = 300;
  if (listRef.current) {
    if (direction === "left") {
      listRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      listRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  }
};

  
  const handleClickRedirect = () => {
    if (params?.departmentSlug !== slug) {
      navigate(`/${redirectBaseUrl}/${slug}`);
    }
    dispatch(resetFilterSideBar());
    setIsChildNodesOpen(!isChildNodesOpen);
  };

  const handleNodeChange = (
    e,
    text,
    funtional_level,
    function_names,
    category_ids
  ) => {
    dispatch(updateNodeFuctionalText(text));
    dispatch(updateNodeFunctionalLevel(funtional_level));
    // if (querySearchKey === "category_ids") {
    //   setSearchParams({ category_ids: category_ids });
    // } else {
    //   setSearchParams({ function_names: function_names });
    // }
  };

  const handleItemClick = (e) => {
    setIsChildNodesOpen(!isChildNodesOpen);
    if (isRootItem) {
      handleClickRedirect();
    } else {
      handleNodeChange(
        e,
        text,
        funtional_level,
        function_names,
        category_ids
      );
      if (node && node.length > 0) {
        setIsChildNodesOpen(!isChildNodesOpen);
      }
    }
  };

  const headerSectionData = useSelector(
   ({ common }) => common.commonDetailsData.header_section
 );

 const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    // slidesToShow: Math.min(featureproductData?.products_list.length, 6),
    slidesToShow: 8,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    slidesToScroll: 1,
    afterChange: (index) => {
    const list = sliderRef.current?.innerSlider?.list;
    if (list) {
      const slideWidth = list.querySelector('.slick-slide')?.offsetWidth || 0;
      list.scrollLeft = slideWidth * index;
    }
  },
    responsive: [
      {
        breakpoint: 1480,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          infinite: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: false,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: false,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
    ],
  };

  return (
    <>
        <div className="category-all-items" >     
        {node?.length > 0 && (
          <div className="child-department-list">
            <div className="catering-item">
              <Slider ref={sliderRef} {...settings}>
                {node?.map((item, index) => (
                  <>
                    <div className="catering-list">
                      <ChildItem
                        key={index}
                        item={item}
                        onClick={onClick}
                        querySearchKey={querySearchKey}
                      />
                    </div>
                  </>
                ))}
              </Slider>
            </div>
          </div>
        )}
      </div>
      <div>
      </div>
    </>
  );
};

const DepartmentListItemNew = React.memo(
  ({ departmentTree, redirectBaseUrl, querySearchKey }) => {
    const [departmentTreeList, setDepartmentTree] = useState(departmentTree);

    const { departmentSlug } = useParams();

    useEffect(() => {
      setDepartmentTree(departmentTree);
    }, [departmentTree]);

    
    return (
      <div>
        {departmentTreeList
          ? departmentTreeList.map((item, index) => (
            <Item
              key={index}
              isRootItem={true}
              isChildNodesOpenDefault={departmentSlug === item.slug}
              {...item}
              redirectBaseUrl={redirectBaseUrl}
              querySearchKey={querySearchKey}
            />
          ))
          : ""}
      </div>
    );
  }
);


export default DepartmentListItemNew;